import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';

export const StyledContainer = styled('div')<{
    $noGutter?: boolean;
    $isMBTOptimization?: boolean;
}>`
    ${({
        theme,
        $noGutter,
        $isMBTOptimization,
    }: {
        theme: Theme;
        $noGutter?: boolean;
        $isMBTOptimization?: boolean;
    }) => `
        margin: ${$noGutter ? theme.tggSpacing(0, 0) : $isMBTOptimization ? theme.tggSpacing([rem(2.5), 0, 0, 0], [6.25, 0, 0, 0]) : theme.tggSpacing([rem(2), 0], [5, 0])};
	`}
`;
